<template>
  <div>
    <div class="card top-draft">
      <div class="">
        <div class="col-lg-12 list-header pad-header-bg clearfix">
          <div class="flex" style="float: left; align-items: center">
            <b-button size="sm" variant="primary" @click="toCreate()">
              <i class="bx bx-plus font-size-16 align-middle me-2"></i>
              导出
            </b-button>
            <el-checkbox
              style="margin-left: 20px; margin-bottom: 0"
              v-model="pageParams.bestScore"
              >导出最佳成绩</el-checkbox
            >
            <!-- <download-excel
              ref="downloadBtn"
              class="export-excel-wrapper"
              :data="DetailsForm"
              :fields="json_fields"
              :header="title"
              name="成绩数据列表.xls"
            >
              <el-button
                style="margin-right: 20px"
                size="mini"
                @click="toCreate()"
                type="primary"
                icon="el-icon-plus"
                >导出</el-button
              >
            </download-excel> -->
          </div>
          <div class="flex" style="float: left"></div>

          <div class="header-item-fix">
            <b-form-input
              class="m-r-10"
              size="sm"
              type="text"
              v-model="pageParams.content"
              placeholder="搜索内容"
              @keyup.enter.native="search"
            ></b-form-input>
            <b-button size="sm" variant="primary" @click="search()">
              <i class="bx bx-search-alt-2 font-size-16 align-middle"></i>
              搜索
            </b-button>
            <b-button
              size="sm"
              variant="outline-secondary"
              @click="resetParams()"
            >
              <i class="bx bx-revision font-size-16 align-middle"></i>
              重置
            </b-button>
          </div>
          <div class="header-item-fix">
            <!-- <el-select
              style="margin-right: 20px"
              placeholder="筛选状态"
              v-model="pageParams.state"
              @change="search"
            >
              <el-option
                v-for="item in statusList"
                :key="item.value"
                :label="item.text"
                :value="item.value"
              >
              </el-option
            ></el-select> -->
            <el-date-picker
              style="max-width: 350px"
              size="mini"
              v-model="daterange"
              type="datetimerange"
              :picker-options="pickerOptions"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="center"
            >
            </el-date-picker>
          </div>
        </div>
        <div class="col-lg-12">
          <div class="table-responsive">
            <table
              class="table table-nowrap table-centered table-striped align-middle"
            >
              <thead>
                <tr>
                  <!-- <th scope="col" style="width: 70px">
                  <b-form-checkbox
                    @change="checkedAll"
                    v-model="indeterminate"
                    checked
                    plain
                  ></b-form-checkbox>
                </th> -->
                  <th scope="col" style="width: 70px">ID</th>
                  <th scope="col" class="w-300">提交人</th>
                  <th scope="col">手机号</th>
                  <th scope="col">答题数</th>
                  <th scope="col">用时</th>
                  <th scope="col">得分</th>
                  <th scope="col">提交时间</th>
                  <th scope="col">操作</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in items" :key="item.id">
                  <!-- <td>
                  <b-form-checkbox
                    v-model="choiceListIds"
                    :value="item.id"
                    checked
                    plain
                  ></b-form-checkbox>
                </td> -->
                  <td>{{ item.id }}</td>
                  <td>{{ item.name || "--" }}</td>
                  <td>{{ item.phone }}</td>
                  <td>
                    {{ item.finishedNum }}
                  </td>
                  <td>{{ secondsToHMS(item.time) }}</td>
                  <td>{{ item.userScore }}</td>
                  <td class="m-200 white-inherit">
                    {{ item.createdAt }}
                  </td>
                  <td>
                    <button
                      type="button"
                      class="btn-sm btn btn-primary m-r-10"
                      @click="toDetail(item.id)"
                    >
                      查看详情
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <app-list-loading ref="loading"></app-list-loading>

          <!-- :isBatch 如果有批量操作就传这个参数 没有就不传
        batchs 批量操作的列表
        pageCallback 分页组件的回调方法 -->
          <pagination
            class="bath_r_20"
            ref="page"
            @pageCallback="pageCallback"
          ></pagination>
        </div>
      </div>
    </div>
    <!-- 删除 -->
    <el-dialog title="删除" :visible.sync="removeDialog" width="30%">
      <span style="">确认删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="removeDialog = false">取 消</el-button>
        <el-button type="primary" @click="checkRemove">确 定</el-button>
      </span>
    </el-dialog>
    <scoreDialog ref="score" @pageCallback="pageCallback"></scoreDialog>
  </div>
</template>

<script>
import Vue from "vue";
import Swal from "sweetalert2";
import pagination from "@/components/pagination/pagination.vue";
// import mediaDialog from "@/router/views/content/video/mediaDialog.vue";
// import $_rotation from "@/server/api/rotation/rotation.api.js";
import momentFocus from "@/server/api/momentFocus";
import scoreDialog from "./scoreDialog.vue";
import question from "@/server/api/question.js";
/**
 * Contacts-list component
 */
export default {
  components: {
    pagination,
    scoreDialog,
  },

  props: {
    // tagList: {
    //   type: Array,
    //   default: () => {
    //     return [];
    //   },
    // },
  },

  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      daterange: "",
      rowData: {},
      drawer: false,
      direction: "rtl",
      power: "",
      choiceListIds: [], //当前所选择的id
      allListIds: [],
      indeterminate: false, //全选
      pageParams: {
        page: 1,
        pageSize: 30,
        content: "",
      },
      currentTag: "",
      items: [],
      batchs: [
        //批量操作有哪些操作
        { text: "批量操作", value: "0" },
        { text: "显示", value: "1" },
        { text: "隐藏", value: "2" },
        { text: "移除", value: "3" },
      ],
      statusList: [
        { text: "冻结", value: 0 },
        { text: "正常", value: 1 },
      ],
      preList: [
        { label: "全部", value: "" },
        { label: "草稿", value: 0 },
        { label: "通过", value: 1 },
        { label: "驳回", value: 2 },
        { label: "待审核", value: 3 },
      ],
      sortList: [
        { text: "阅读", value: "viewNum" },
        { text: "评论", value: "commentNum" },
        { text: "日期", value: "createTime" },
      ],
      tagStatus: "0",
      addDialog: false,
      addForm: { name: "", radio: 0 },
      titleFlag: "创建",
      removeDialog: false,
      cityID: "",
      listID: "",
      title: "成绩数据",
      json_fields: {
        ID: "id",
        提交人: "name",
        手机号: "phone",
        答题数: "finishedNum",
        用时: "time",
        得分: "userScore",
        提交时间: "updatedAt",
      },
      DetailsForm: [],
    };
  },

  watch: {
    choiceListIds: function () {
      if (
        this.choiceListIds.length == this.allListIds.length &&
        this.choiceListIds.length > 0
      ) {
        this.indeterminate = true;
      } else {
        this.indeterminate = false;
      }
    },
    // DetailsForm(val, oldV) {
    //   if (val.length > 0) {
    //     setTimeout(() => {
    //       this.$refs.downloadBtn.$el.click();
    //     }, 10); //监听导出数据，判断满足条件等一下下触发导出点击事件
    //   }
    // },
  },

  mounted() {
    this.cityID = Number(this.$route.query.id);
    // console.log(this.$route.query);
    this.getList();
  },

  created() {},

  methods: {
    showPre(url) {
      this.rowData.previewUrl = url;
      this.drawer = true;
    },
    //获取列表数据
    getList() {
      this.pageParams.id = this.cityID;
      this.cleanObj(this.pageParams);
      this.items = [];
      this.$refs.loading.show();

      question.historyList(this.pageParams).then((resp) => {
        if (resp.data) {
          if (this.$refs.loading) {
            this.$refs.loading.hide(resp.data.items);
          }
          if (resp.data.items) {
            let ids = [];
            resp.data.items.map((item) => {
              ids.push(item.id);
            });
            this.choiceListIds = [];
            this.allListIds = ids; //当前列表全部id
            this.items = resp.data.items;
            let pages = {
              page: resp.data.page, //第几页
              pageSize: resp.data.pageSize, //每页多少条
              total: resp.data.total, //全部有多少条数据
              totalPages: resp.data.totalPages, //全部有几页
            };
            // 获取列表后调用组件的方法传入分页信息
            this.$nextTick(() => {
              if (this.$refs.page) {
                this.$refs.page.setPages(pages);
              }
            });
          }
        }
      });
    },

    //给组件的回调
    pageCallback(obj) {
      if (obj.code === "pageSize") {
        if (obj.ps == 100) {
          this.pageParams.pageSize = 100;
          this.getList();
        } else if (obj.ps == 50) {
          this.pageParams.pageSize = 50;
          this.getList();
        } else {
          this.pageParams.pageSize = 30;
          this.getList();
        }
      }

      if (obj.code === "page") {
        //更改页码
        this.pageParams.page = obj.page;
        this.getList();
      }
      if (obj.code === "batch") {
        //处理批量操作
        if (obj.batch == 1) {
          if (this.choiceListIds.length) {
            //点击显示的处理方法
            this.batchShow();
          } else {
            Vue.swal("请选择要显示的内容");
            return;
          }
        }
        if (obj.batch == 2) {
          if (this.choiceListIds.length) {
            //点击隐藏的处理方法
            this.batchHide();
          } else {
            Vue.swal("请选择要隐藏的内容");
            return;
          }
        }
        if (obj.batch == 3) {
          if (this.choiceListIds.length) {
            //点击撤稿的处理方法
            this.batchRevert();
          } else {
            Vue.swal("请选择要移除的内容");
            return;
          }
        }
      }
    },

    //导出
    toCreate() {
      // this.pageParams.relationId = this.cityID;
      if (this.daterange) {
        this.pageParams.startTime = this.daterange[0].format(
          "yyyy-MM-dd hh:mm:ss"
        );
        this.pageParams.endTime = this.daterange[1].format(
          "yyyy-MM-dd hh:mm:ss"
        );
      } else {
        this.pageParams.startTime = "";
        this.pageParams.endTime = "";
      }

      let params = JSON.parse(JSON.stringify(this.pageParams));
      delete params.page;
      delete params.pageSize;
      // let url =
      //   env.API_HOST +
      //   `/questionnaire/history/export?id=${params.id}&startTime=${
      //     params.startTime || ""
      //   }&endTime=${params.endTime || ""}&content=${
      //     params.content || ""
      //   }&bestScore=${params.bestScore || ""}`;
      let url =
        env.API_HOST +
        `/questionnaire/history/export?id=${params.id}${
          params.startTime ? "&startTime=" + params.startTime : ""
        }${params.endTime ? "&endTime=" + params.endTime : ""}${
          params.content ? "&content=" + params.content : ""
        }${
          params.bestScore
            ? "&bestScore=" + params.bestScore
            : ""
        }`;

      var a = document.createElement("a");
      document.body.appendChild(a);
      a.style = "display: none";
      a.href = url;
      // a.download = '订单模板.xls';
      a.click();
      a.remove();
      // question.historyListExport(params).then((resp) => {
      //   if (resp.data) {
      //     // this.DetailsForm = resp.data.items;
      //     console.log(resp);
      //   }
      // });
    },

    //去编辑
    toDetail(id) {
      this.$refs.score.showModel(id);

      // this.$router.push({
      //   name: "mediasDetail",
      //   query: { source: "momentFocus", id: item.id, allModify: "true" },
      // });
    },
    //搜索
    search() {
      this.pageParams.page = 1;
      if (this.daterange) {
        this.pageParams.startTime = this.daterange[0].format(
          "yyyy-MM-dd hh:mm:ss"
        );
        this.pageParams.endTime = this.daterange[1].format(
          "yyyy-MM-dd hh:mm:ss"
        );
      }
      this.getList();
    },

    //重置搜索参数
    resetParams() {
      this.pageParams.page = 1;
      this.pageParams.content = "";
      this.daterange = "";
      delete this.pageParams.startTime;
      delete this.pageParams.endTime;
      this.pageParams.bestScore = false;

      this.getList();
    },

    // // 列表全选
    // checkedAll() {
    //   if (this.indeterminate) {
    //     this.choiceListIds = this.allListIds;
    //   } else {
    //     this.choiceListIds = [];
    //   }
    // },

    //批量隐藏
    // batchHide(item) {
    //   Swal.fire({
    //     title: "确定隐藏?",
    //     icon: "question",
    //     showCancelButton: true,
    //     confirmButtonColor: "#f46a6a",
    //     cancelButtonColor: "#74788d",
    //     confirmButtonText: "隐藏",
    //     cancelButtonText: "取消",
    //   }).then((result) => {
    //     if (result.value) {
    //       let params = { type: 0 };
    //       if (item) {
    //         params.ids = [];
    //         params.ids.push(item.id);
    //       } else {
    //         params.ids = this.choiceListIds;
    //       }
    //       $_rotation.batch(params).then((resp) => {
    //         if (resp.code == 0) {
    //           this.getList();
    //           Vue.swal({
    //             icon: "success",
    //             title: "隐藏成功！",
    //             showConfirmButton: false,
    //             timer: 1000,
    //           });
    //         } else {
    //           Vue.swal(resp.msg);
    //         }
    //       });
    //     }
    //   });
    // },
    //批量显示
    // batchShow(item) {
    //   Swal.fire({
    //     title: "确定显示?",
    //     icon: "question",
    //     showCancelButton: true,
    //     confirmButtonColor: "#f46a6a",
    //     cancelButtonColor: "#74788d",
    //     confirmButtonText: "显示",
    //     cancelButtonText: "取消",
    //   }).then((result) => {
    //     if (result.value) {
    //       let params = { type: 1 };
    //       if (item) {
    //         params.ids = [];
    //         params.ids.push(item.id);
    //       } else {
    //         params.ids = this.choiceListIds;
    //       }
    //       $_rotation.batch(params).then((resp) => {
    //         if (resp.code == 0) {
    //           this.getList();
    //           Vue.swal({
    //             icon: "success",
    //             title: "显示成功！",
    //             showConfirmButton: false,
    //             timer: 1000,
    //           });
    //         } else {
    //           Vue.swal(resp.msg);
    //         }
    //       });
    //     }
    //   });
    // },

    //批量删除
    // batchRevert() {
    //   Swal.fire({
    //     title: "确定移除?",
    //     icon: "question",
    //     showCancelButton: true,
    //     confirmButtonColor: "#f46a6a",
    //     cancelButtonColor: "#74788d",
    //     confirmButtonText: "确定",
    //     cancelButtonText: "取消",
    //   }).then((result) => {
    //     if (result.value) {
    //       let ids = [];
    //       this.items.map((val) => {
    //         if (this.choiceListIds.indexOf(val.id) !== -1) {
    //           ids.push(val.topId);
    //         }
    //       });
    //       let params = { ids: ids };
    //       console.log(params);
    //       momentFocus.media.del(params).then((resp) => {
    //         if (resp.code == 0) {
    //           Vue.swal({
    //             icon: "success",
    //             title: "移除成功！",
    //             showConfirmButton: false,
    //             timer: 1000,
    //           });
    //           this.getList();
    //         } else {
    //           Vue.swal(resp.msg);
    //         }
    //       });
    //     }
    //   });
    // },

    //删除
    remove(item) {
      this.listID = item.id;
      this.removeDialog = true;
    },
    //确定删除
    checkRemove() {
      let ids = [];
      this.items.map((val) => {
        if (val.id === this.listID) {
          ids.push(val.topId);
        }
      });
      let params = { ids: ids };
      momentFocus.media.del(params).then((res) => {
        if (res.code == 0) {
          this.removeDialog = false;
          Vue.swal({
            icon: "success",
            title: "删除成功！",
            showConfirmButton: false,
            timer: 1000,
          });
          this.getList();
        } else {
          Vue.swal(resp.msg);
        }
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
/* .creDialog {
  margin-top: 45vh !important;
} */
</style>
